import { createContext, useState, useEffect } from 'react';

export const TestingContext = createContext();

export const TestingProvider = ({ children }) => {
  // localStorage에서 초기값 불러오기
  const getInitialTestingObj = () => {
    try {
      const saved = localStorage.getItem('testingObj');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  };

  const [testingObj, setTestingObj] = useState(getInitialTestingObj());

  // 값이 변경될 때마다 localStorage에 저장
  useEffect(() => {
    if (testingObj) {
      localStorage.setItem('testingObj', JSON.stringify(testingObj));
    } else {
      localStorage.removeItem('testingObj');
    }
  }, [testingObj]);

  return (
    <TestingContext.Provider value={{ testingObj, setTestingObj }}>
      {children}
    </TestingContext.Provider>
  );
};